<template>
  <base-card>
    <h1>Seasons List</h1>
    <div>
      <ol>
        <li v-for="season in seasonsList" :key="season.seasonId">
          {{ season.year }} NFL Season is {{ season.isActive ? "Active" : "Inactive" }} and
          <!-- {{ season.tournamentStartDate.toDateString() }} {{ season.tournamentStartDate.toTimeString() }} - -->
          {{ season.tournamentPickingOpen ? "Picks are Open" : "Picks are Closed" }}
          <!-- {{ season.seasonId }} -->
        </li>
      </ol>
    </div>
    <base-button @click="createSeason">Create New Season</base-button>
  </base-card>
</template>

<script>
export default {
  computed: {
    seasonsList() {
      return this.$store.getters["seasons/seasonsList"];
    },
  },
  methods: {
    createSeason() {
      console.log("In createSeason");

      const season = {
        seasonId: null,
        year: new Date().getFullYear(), // get the current year
        isActive: false,                // leave this false since you manually have to make the previous Season inactive, first
        conferences: [ 'AFC', 'NFC'],
        divisions: [ 'North', 'South', 'East', 'West'],
        teamsPerDivision: 4,
        seasonGamesPerTeam: 17, // Verify each year
        regularSeasonWeeks: 18, // Verify each year
        // Note for the below dates, the month is 0-based, so 8 = September
        seasonStartDate: new Date(2022, 8, 8, 18, 20),      // Update each year (this is the time of the first game of Week 1)
        seasonEndDate: new Date(2023, 1, 12),               // Update each year (currently not used, but should be the date of the Super Bowl (for now))
        tournamentStartDate: new Date(2021, 8, 15, 18, 15), // Update each year (this is the time of the first game of Week 2)
        tournamentPickingOpen: true,    // this can be true since the previous season should already be false
      }

      console.log("In createSeason: Season = ", season);
      this.$store.dispatch("seasons/createSeason", season);
    }
  },
};
</script>

<style scoped>
/* .button--edit {
  line-height: .5rem;
  margin-left: 1rem;
} */
</style>